import React from "react";

export default function Wrapper(props) {
  return (
    <div className="expired_alert_bg_img_login">
      <div className="expired_alert_login_bg_height">
        <div className="expired_alert_login_bg_width">
          <div className="row">{props.children}</div>
        </div>
      </div>
    </div>
  );
}
